/* eslint-disable no-restricted-globals,no-console */
/* location */
import axios from 'axios';
import camelize from 'camelize';
import snakeCase from './snakecaseKeys';
import { DEV_ENV, API_URI, DISABLE_LOGS } from '../constants/env';
import { trackHttpError } from './http-error';

const apiInit = options =>
  axios.create({
    baseURL: API_URI,
    ...options,
  });

const api = (endpoint, options, type = 'post') => ({
  send(payload) {
    if (DEV_ENV && !DISABLE_LOGS) {
      console.group('API Request');
      console.info(`Endpoint: ${location.protocol}${API_URI}/${endpoint}`);
      console.info('Options:', options || 'No');
      console.info(`Type: ${type.toUpperCase()}`);
      console.groupEnd();
    }

    const shouldSnakeCase = payload && !(payload instanceof FormData);
    const method = apiInit(options)[type];

    return method(endpoint, shouldSnakeCase ? snakeCase(payload) : payload)
      .then(response => {
        if (response.data instanceof Blob) return response;
        return camelize(response);
      })
      .catch(err => {
        trackHttpError(err);
        return camelize(err.response);
      });
  },
});

export const makeAPI = options => {
  const instance = apiInit({});
  return instance.request(options);
};

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js